import React from 'react'
import Modal from '@mui/material/Modal'
import { makeStyles } from '@mui/styles'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import AddIcon from '@mui/icons-material/Add'
import { Grid } from '@mui/material'
import TextField from '@mui/material/TextField'

export default function AreaSupervisorModal({ data = [], open = false, onClickCancel = () => { }, onClickSubmint = () => { }, onSearch = () => { } }) {
    const classes = useStyles()

    return (
        <div style={{ alignContent: 'center' }}>
            <Modal
                scrollable="true"
                open={open}
                onClose={onClickCancel}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className={classes.modalStyle}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="h6" component="h2">
                            เลือกผู้ดูแล พื้นที่
                        </Typography>
                        <Typography variant="h6" component="h2" >
                            <TextField onChange={(e) => onSearch(e.target.value)} style={{ width: '100%', }} size='small' id="outlined-basic" variant="outlined" placeholder='ค้นหา' />
                        </Typography>
                    </div>
                    <Box sx={{ width: '100%' }}>
                        <Grid container mt={1} rowSpacing={1} >
                            <Grid item xs={1}>
                                ลำดับ
                            </Grid>
                            <Grid item xs={3}>
                                ชื่อ-นามสกุล
                            </Grid>
                            <Grid item xs={3}>
                                ตำแหน่ง
                            </Grid>
                            <Grid item xs={3}>
                                ชื่อบริษัท
                            </Grid>
                            <Grid item xs={2}>
                            </Grid>
                        </Grid>
                        <div className={classes.divLine}></div>
                        {
                            data.map((data, i) => {
                                return (
                                    <React.Fragment key={i}>
                                        <Grid container mt={1} rowSpacing={1} >
                                            <Grid item xs={1}>
                                                {i + 1}
                                            </Grid>
                                            <Grid item xs={3}>
                                                {data.firstName} {data.lastName}
                                            </Grid>
                                            <Grid item xs={3}>
                                                {data.enterprisePositionName}
                                            </Grid>
                                            <Grid item xs={3}>
                                                {data.enterpriseName}
                                            </Grid>
                                            <Grid item xs={2} style={{ paddingTop: 1 }}>
                                                <Button onClick={() => onClickSubmint({ id: data.id, firstName: data.firstName, lastName: data.lastName })} variant="contained" color="success"><AddIcon /></Button>
                                            </Grid>
                                        </Grid>
                                        <div className={classes.divLine}></div>
                                    </React.Fragment>
                                )
                            })
                        }
                    </Box>
                </Box>
            </Modal>
        </div >
    )
}

const useStyles = makeStyles((theme) => ({
    modalStyle: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '40%',
        border: '1px solid #000',
        boxShadow: 24,
        backgroundColor: 'white',
        padding: 20,
        height: 500,
        overflow: "scroll",
        borderRadius: 10,
    },
    divLine: {
        height: 1.1, backgroundColor: '#12203A',
        width: '100%', marginTop: 10
    },
}))